import React from 'react'
import Button from './Button'

const ButtonRight = (props) => {
  return (
    <Button
      icon="ChevronRight"
      {...props}
    />
  )
}

export default ButtonRight
